import React from 'react';

import Banner from '../components/Banner';
import Footer from '../components/Footer';
import styles from './About.module.css';

const About = () => {
    return (
        <div className='Page About'>
            <Banner></Banner>
            <section className={styles.section}>
                <p>I am a fourth-year Mechanical Engineering student at UCLA with a passion for automotive and aerospace engineering. My lifelong interest in cars first led me to mechanical engineering and a desire to design and innovate in the field. Through my work on engineering teams and independent projects, I have also developed a strong interest in rocketry and aerospace. These experiences have broadened my fascination with engines and propulsion systems into an enthusiasm for advanced transportation and space exploration.</p>

                <p>Over the past four years, I have worked on a wide range of projects that have strengthened my skills in design, manufacturing, and engineering problem-solving. I have spent hundreds of hours using SolidWorks and ANSYS to design and analyze everything from go-kart chassis and rocket propellant tanks to combat robots. I also have extensive hands-on experience with manual and CNC machining, which allows me to carry designs from an initial concept through fabrication and testing.</p>

                <p>My resume and a condensed engineering portfolio showcasing many of these designs are available below. For a closer look at a specific project or skill use the menu to explore my design process, technical contributions, and lessons learned.</p>

            </section>
            <Footer></Footer>
        </div>
    );
};

export default About;
